var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    //1
    id: "certificate_management_number",
    label: "証書管理番号",
    type: types.INPUT,
    listen_for_value: "management_number_force_update",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_information: "D",
    },
  },
  {
    //2
    id: "license_certificate_type",
    label: "ライセンス証書種類",
    type: types.INPUT,
    error_if_blank: true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    //3
    id: "certificate_individual_number",
    label: "証書個別番号",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    //4
    id: "sales_company",
    label: "販売会社",
    type: types.SELECT_BOX4,
    listen_for_value: "maker_force_update",
    api_uniq_grouping:true,
    event_emit_bus_key:"associated_device_manufacture_name_software_name",
    api:"/master_maker/list_maker_name",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    //5
    id: "remark",
    label: "備考",
    type: types.TEXT_AREA,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },

  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_certificate.js